import { copy } from '../content/copy';
import { SectionLabel } from '../components/SectionLabel';

export function Faq() {
  const { faq } = copy;
  return (
    <section id="faq" className="bg-l-paper-soft bg-math-pattern px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[820px]">
        <SectionLabel>РАЗДЕЛ 06 · ВОПРОСЫ</SectionLabel>
        <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-10">
          {faq.title}
        </h2>
        <div className="flex flex-col">
          {faq.items.map((item, i) => (
            <details
              key={item.q}
              open={i === 0}
              className="group border-t border-l-rule py-5 last:border-b"
            >
              <summary className="flex justify-between items-center cursor-pointer list-none font-sans text-l-ink-deep text-[17px] font-semibold">
                <span>{item.q}</span>
                <span className="ml-4 font-display text-l-terracotta text-2xl leading-none transition-transform group-open:rotate-45">
                  +
                </span>
              </summary>
              <p className="mt-3 font-sans text-l-ink text-[16px] leading-[1.6]">
                {item.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
